/* -------------------------- Design imports start -------------------------- */
import { Card, CardContent, Modal, TextField, Typography } from '@mui/material'
/* --------------------------- Design imports end --------------------------- */
/* ------------------------ Functional imports start ------------------------ */
import React, { type ReactElement, useState } from "react";
import { useTranslation } from 'react-i18next'

import useMobileService from '../../hooks/useMobileService'
import Button from '../Button'
/* ------------------------- Functional imports end ------------------------- */

interface Props {
  title: string
  description?: string
  textfieldLabel?: string
  placeholder?: string
  defaultValue?: string //Todo
  fallbackValue: string
  fetchValueBy: (value: string) => void
  open: boolean
  setOpen: (open: boolean) => void
  onClose?: () => void
  onCancel?: () => void
  onConfirm?: () => void
}

/**
 * Dialog that lets you name a new folder and create it
 */
/* -------------------------------------------------------------------------- */
/*                               Start Component                              */
/* -------------------------------------------------------------------------- */
export default function NewFolderDialog(props: Props): ReactElement {
  /* -------------------------- Non state data start -------------------------- */
  const {
    title,
    description,
    textfieldLabel = '',
    placeholder = '',
    //defaultValue,
    fallbackValue,
    fetchValueBy,
    open,
    setOpen,
    onClose = () => null,
    onCancel = () => null,
    onConfirm = () => null,
  } = props
  const isMobile = useMobileService()
  let size
  isMobile ? (size = { height: '40%', width: '90%' }) : (size = { height: '30%', width: '40%' })
  /* --------------------------- Non state data end --------------------------- */
  /* ---------------------------- Flag states start --------------------------- */
  /* ----------------------------- Flag states end ---------------------------- */
  /* ---------------------------- Data states start --------------------------- */
  const { t } = useTranslation()
  const [value, setValue] = useState<string>('')
  /* ----------------------------- Data states end ---------------------------- */

  /* ------------------------------ Effects start ----------------------------- */
  /* useEffect(() => {
        defaultValue && setValue(defaultValue)
    }, []) */
  /* ------------------------------- Effects end ------------------------------ */

  /* ------------------------ Callback functions start ------------------------ */
  const handleCancel = (): void => {
    setOpen(false)
    setValue('')
    onCancel()
  }

  const handleConfirm = (): void => {
    setOpen(false)
    if (value.length === 0) {
      fetchValueBy(fallbackValue)
    } else {
      fetchValueBy(value)
    }
    setValue('')
    onConfirm()
  }

  const handleClose = (): void => {
    setOpen(false)
    setValue('')
    onClose()
  }
  /* ------------------------- Callback functions end ------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                              Render component                              */
  /* -------------------------------------------------------------------------- */
  return (
    <Modal open={open} onClose={handleClose}>
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: size.height,
          width: size.width,
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            width: '100%',
            paddingBottom: '16px',
          }}
        >
          <Typography variant="h6">{title}</Typography>
          <div aria-label="textfieldModal-body">
            <span>{description && description}</span>
            <TextField
              value={value}
              id="folderName"
              placeholder={placeholder}
              label={textfieldLabel}
              onChange={e => setValue(e.target.value)}
              /* eslint-disable-next-line jsx-a11y/no-autofocus */
              autoFocus
              margin="dense"
              type="text"
              fullWidth
              variant="standard"
            />
          </div>
          <div
            aria-label="textfieldModal-actions"
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Button
              id="cancelButton"
              style={{ color: '#16a9e4' }}
              variant="outlined"
              onClick={handleCancel}
            >
              {t('common:interaction.button.cancel')}
            </Button>
            <Button id="confirmButton" variant="contained" onClick={handleConfirm}>
              {t('common:interaction.button.confirm')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </Modal>
  )
}
